// extracted by mini-css-extract-plugin
module.exports = {"NavigationItem":"NavigationItem_NavigationItem__1mUkZ","active":"NavigationItem_active__1esC4"};